import { render, staticRenderFns } from "./ownList.vue?vue&type=template&id=5caeaa3a&scoped=true&"
import script from "./ownList.vue?vue&type=script&lang=js&"
export * from "./ownList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caeaa3a",
  null
  
)

export default component.exports